import { useState, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import { useStore, useSelector } from "react-redux";

// helper
import * as helper from "./helper";

// controllers
import { SizeController, CategoryController } from "controllers";

// reducers
import { selectCountry } from 'hyc-store/reducers/countries/countriesReducer';
import { success, error as toastError } from "hyc-store/reducers/toast";

// components
import { RowSize } from "./row-size";
import { Button } from "shared/components/bulma/button";
import { ActionBar } from "shared/components/action-bar";

const SIZES = [
    { size: "XS/34" },
    { size: "S/36" },
    { size: "M/38" },
    { size: "M/40" },
    { size: "L/42" },
    { size: "XL/44" },
    { size: "XXL/46" },
    { size: "XXXL/48" },
    { size: "ONESIZE" }
];
const ProductsUpload = () => {

    const [data, setData] = useState([...SIZES]);
    const [model, setModel] = useState(undefined);
    const [loading, setLoading] = useState(false);

    const { id } = useParams();
    const history = useHistory();
    const store = useStore();
    const country = useSelector(selectCountry);

    const handleChange = (event) => {
        const { size, ...rest } = event;
        const index = data.findIndex((element) => element.size === size);
        const rowData = data[index];
        data[index] = { ...rowData, ...rest };

        setData([...data]);
    }
    // TODO: Since SIZES is being updated each time data is changed, we decided to copypaste that here. A better solution would be to find a soluton not to copy and update SIZES

    const reset = () => {
        setData([
            { size: "XS/34" },
            { size: "S/36" },
            { size: "M/38" },
            { size: "M/40" },
            { size: "L/42" },
            { size: "XL/44" },
            { size: "XXL/46" },
            { size: "XXXL/48" },
            { size: "ONESIZE" }
        ]);
    };

    const handleNextBarcode = (event) => {
        const { nextBarcode, size } = event;
        const index = data.findIndex((element) => element.size === size);
        const nextRow = data[index + 1];
        if (nextRow) {
            nextRow.startBarcode = nextBarcode;
        }

        setData([...data]);
    }
    const generateLocationCode = async (rowSize) => {

        const size = await SizeController.getSizeByValue(rowSize);
        const category = await CategoryController.getCategoryByValue(model.category);
        return size.code + category.code;
    };

    const save = async () => {
        setLoading(true);
        let res = 0;

        for (const row of data) {
            if (row.endBarcode === undefined) {
                continue;
            }
            // SPECIAL CASE FOR M (merging 38 and 40)
            // if size is 38 or 40, size should be "M/38/40"
            const size = row.size.includes('M') ? "M/38/40" : row.size;

            const location = await generateLocationCode(size);

            const rowPayload = { ...model, location, size, cycles: 0, status: "available", model_ref: `/model/${model.SKU}`, market: country, model: model.SKU };
            delete rowPayload.SKU;
            delete rowPayload.normalized_SKU;
            const range = helper.createRange(row);
            const existingBarcodes = await helper.checkBarcodes(range);

            if (existingBarcodes.length > 0) {
                store.dispatch(toastError(`${existingBarcodes} already exists`));
                setLoading(false);
                return;
            }

            for (const barcode of range) {
                // verify that barcodes are available
                const payload = { ...rowPayload, barcode };
                await helper.createProduct(payload);
                res = res + 1;
            };
        };

        // confirmation in Toast
        await reset();
        setLoading(false);
        store.dispatch(success(`Congrats, you created ${res} products!`));
        if (res !== 0) {
            const url = "/overstock";
            history.push(url);
        } else {
            store.dispatch(toastError(`Oups, something went wrong!`));
        };
        // go back to overstock dashboard

    }

    const Titles = () => {
        return (
            <div className="columns is-variable is-8">
                <div className="column">
                    <p className="title is-5">Size</p>
                </div>
                <div className="column">
                    <p className="title is-5">First Barcode</p>
                </div>
                <div className="column is-2">
                    <p className="title is-5">Quantity</p>
                </div>
                <div className="column">
                    <p className="title is-5">Last Barcode</p>
                </div>
                <div className="column is-2">
                </div>
            </div>
        );
    }

    useEffect(() => {
        const initModel = async () => {
            const retrievedModel = await helper.getModel(id);
            setModel(retrievedModel);
        };
        if (!model) {
            initModel();
        };
    }, [id, model]);

    return (
        <div className="container">
            <div className="container has-text-centered m-4 pt-4 pb-6">
                <p className="title is-size-2 centered">
                    Upload products: {id}
                </p>
                <div className="container m-4">
                    <div className="columns is-gapless">
                        <div className="column is-3 container m-4 pt-4">
                            <p className="image is-4by5">
                                <img src={model ? model.imageURLs[0] : null} alt="Not yet" />
                            </p>
                        </div>
                        <div className="column">
                            <Titles />
                            {data.map((row) =>
                                <RowSize key={row.size} {...row} onChange={handleChange} onNextBarcode={handleNextBarcode} />
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <ActionBar>
                <Button className={`is-info`}
                    onClick={reset}
                >Reset</Button>
                <Button className={`is-primary ${loading ? 'is-loading' : ''}`}
                    onClick={save} disabled={loading}
                >Upload the products</Button>
            </ActionBar>
        </div >
    );
}

export { ProductsUpload };
